import React from "react"

const Header = ({ Logo }) => {
  return (
    <>
      <div className="header flex flex-row center items-center" style={{ height: "80px" }}>
        <img className="pa1 ml4 no-focus" style={{ height: "3rem" }} src={Logo} alt="header-logo" />
      </div>
    </>
  )
}

export default Header
